import { createSelector } from "reselect";

import type { RootState } from "Store/configureStore";

const selectEnvironmentDomain = ({ projectEnvironmentDomain }: RootState) =>
  projectEnvironmentDomain;

// Project's Environment Domains
export const environmentDomainsSelector = createSelector(
  selectEnvironmentDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectEnvironmentDomain, { projectId }) => {
    return projectEnvironmentDomain[projectId]?.data ?? [];
  }
);

export const environmentDomainsLoadingSelector = createSelector(
  selectEnvironmentDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectEnvironmentDomain, { projectId }) =>
    projectEnvironmentDomain[projectId]?.loading
);

export const environmentDomainsErrorSelector = createSelector(
  selectEnvironmentDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectEnvironmentDomain, { projectId }) => {
    return projectEnvironmentDomain[projectId]?.errors;
  }
);

export const environmentDomainsStatusSelector = createSelector(
  selectEnvironmentDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectEnvironmentDomain, { projectId }) =>
    projectEnvironmentDomain[projectId]?.status
);
